export default "__VITE_ASSET__IegULVQZ__";